
    import { defineComponent } from 'vue';
    import XBreadcrumb from '../../components/Breadcrumb.vue';
    import capitalRangeService from '@/apps/shared/services/capitalRange-service';
    import typesOptionsGroupService from '@/apps/shared/services/typesOptionsGroup-service';
    import theftQuotationService from '@/apps/shared/services/theftQuotation-service';
    export default defineComponent({
        components: {
            XBreadcrumb,
        },
        data() {
            return {
                rangeSelected: null,
                data: [],
                isBack: false,
                values: [
                    {
                        code: 0,
                        text: "",
                    }
                ],
                dataAmparo: [],
                range: null,
                relationId: null,
                quotationId: null,
                checkValid: true,
                breadcrumItems: [
                    { text: 'Inicio', path: '/movilidad' },
                    { text: 'Cotizador de Movilidad', path: '/movilidad/cotizarMovilidad' },
                    { text: 'Valor del Vehiculo', path: 'movilidad/valorVehiculo' },
                ],
            }
        },
        methods: {
            getTypesOptionsGroup: function () {
                var dataVehicle = sessionStorage.getItem("DataVehicle")
                var vehicle = JSON.parse(dataVehicle!)
                return new Promise<any>(async (resolve) => {
                    sessionStorage.removeItem("ResponseAmparos");
                    sessionStorage.removeItem("DataQuotation");
                    var quotationDataResult = [];
                    var rangeId = this.range;
                    var productId = 936;
                    var securityGroup = '';
                    let userName = '';
                    let userToken = '';
                    let tokenType = "";
                    let correlationInformation = "";
                    let onDate = new Date().toISOString();
                    var expiracion = new Date();
                    expiracion.setFullYear(expiracion.getFullYear() + 1)
                    this.quotationId = null;
                    this.relationId = null;
                    await typesOptionsGroupService.getTypesOptionsGroup(productId, securityGroup, (rangeId != null) ? parseInt(rangeId) : 1, onDate, correlationInformation, userName, userToken, tokenType)
                        .then(async responseAmparos => {
                            if (!responseAmparos) {
                                window.globalThis.dataLayer.push({ 'product': 'movilidad', 'event': 'errorServidor', 'paso': 'cotizador-movilidad-valor' });
                            } else {
                                sessionStorage.setItem("ResponseAmparos", JSON.stringify(responseAmparos));
                                var body;
                                this.dataAmparo = responseAmparos;
                                for (let o of this.dataAmparo) {
                                    var coverCustomitationsArray = [];
                                    var amparoTheftOptionsArray = [];
                                    o.amparoTheftOptions.forEach(amparoOptions => {
                                        var coverCustomizations = {
                                            coverNumber: amparoOptions.coverCode,
                                            capital: 0,
                                            deductibleType: 0,
                                            rate: 0
                                        };
                                        coverCustomitationsArray.push(coverCustomizations);
                                        var amparoTheftOptions = {
                                            coverCode: amparoOptions.coverCode,
                                            amparoTypes: amparoOptions.amparoTypes,
                                            amparoOption: amparoOptions.amparoOption,
                                            capital: amparoOptions.capital,
                                            amparoTypesDescription: amparoOptions.amparoTypesDescription
                                        }
                                        amparoTheftOptionsArray.push(amparoTheftOptions);
                                    });
                                    body = JSON.stringify({
                                        userName: userName,
                                        userToken: userToken,
                                        tokenType: tokenType,
                                        correlationInformation: correlationInformation,
                                        originRequest: "2",
                                        coverCustomizations: coverCustomitationsArray,
                                        clientIdentify: {
                                            documentType: "D",
                                            documentNumber: 0
                                        },
                                        relationId: (this.relationId != null ? this.relationId : 0),
                                        quotationId: this.quotationId != null ? this.quotationId : null,
                                        amparoTheftOptions: amparoTheftOptionsArray,
                                        mobilityTypeId: parseInt(vehicle.mobilityTypeId)
                                    });
                                    await theftQuotationService.createTheft936Quotation(body)
                                        .then(async responseTheft936Quotation => {
                                            if (!responseTheft936Quotation) {
                                                NF.Notification.show({
                                                    type: NF.Notification.Type.ERROR,
                                                    title: 'Error',
                                                    content: 'Se produjo un error al cotizar.',
                                                    position: NF.Notification.Positions.TOP_RIGHT,
                                                    clickClose: true,
                                                    autoHideDelay: 10000,
                                                });
                                                window.globalThis.dataLayer.push({ 'product': 'movilidad', 'event': 'errorServidor', 'paso': 'cotizador-movilidad-valor' });
                                                NF.UI.Page.unblock();
                                            } else {
                                                var pp = {
                                                    plans: responseTheft936Quotation.plans,
                                                    quotationId: responseTheft936Quotation.quotationId,
                                                    relationId: responseTheft936Quotation.relationId,
                                                }
                                                this.quotationId = pp.quotationId;
                                                this.relationId = responseTheft936Quotation.relationId;
                                                quotationDataResult.push(pp);
                                                sessionStorage.setItem("DataQuotation", JSON.stringify(quotationDataResult));
                                                if (this.dataAmparo.length == quotationDataResult.length) {
                                                    resolve(true)
                                                    this.$router.push({
                                                        name: 'plans-view',
                                                    })
                                                    NF.UI.Page.unblock();
                                                }
                                            }
                                        });
                                }
                            }
                        })
                });
            },
            getCapitalRanges() {
                var productId = 936;
                var securityGroup = '';
                let userName = '';
                let userToken = '';
                let tokenType = "";
                let correlationInformation = "";
                let onDate = new Date().toISOString();
                capitalRangeService.getCapitalRange(onDate, productId, securityGroup, correlationInformation, userName, userToken, tokenType)
                    .then(response => {
                        if (!response) {
                            window.globalThis.dataLayer.push({ 'product': 'movilidad', 'event': 'errorServidor', 'paso': 'cotizador-movilidad-cotizacion' });
                        }
                        else {
                            this.values = response.map(element => ({ ...element, code: element["capitalRangeCode"], text: element["description"] }));
                            NF.UI.Page.unblock();
                        }
                    })
            },
            volver() {
                sessionStorage.setItem("pressBack", "true");
                this.$router.push({
                    name: 'cotizador-movilidad',
                })
            },
            onSelectedRange(description, code) {
                sessionStorage.setItem("ExitOrContinueModal", "false");
                this.rangeSelected = description
                setTimeout(() => {
                    NF.UI.Page.block();
                    sessionStorage.removeItem("ResponseAmparos");
                    sessionStorage.removeItem("DataQuotation");
                    sessionStorage.removeItem("rangeSelected")
                    this.checkValid = true;
                    this.range = code;
                    this.getTypesOptionsGroup();
                    sessionStorage.setItem("rangeSelected", JSON.stringify({
                        descriptionRange: description,
                        codeRange: code
                    }));
                    sessionStorage.setItem("FromTabThree", "true");
                }, 300);
            }
        },
        mounted() {
            window.globalThis.dataLayer.push({ 'product': 'movilidad', 'event': 'cotizador-movilidad-cotizacion' });
            sessionStorage.removeItem("ResponseAmparos");
            sessionStorage.removeItem("DataQuotation");
            sessionStorage.setItem("ExitOrContinueModal", "true");
            this.getCapitalRanges();
            var valueRangeSelected = sessionStorage.getItem("rangeSelected")
            if (valueRangeSelected != null) {
                this.rangeSelectedJson = JSON.parse(valueRangeSelected!);
                this.rangeSelected = this.rangeSelectedJson.descriptionRange;
                this.isBack = true;
            } else {
                this.isBack = false;
            }
        },
    })
